/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries
 */
export interface PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries {
    /**
     * 履歴ID
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries
     */
    logId: number;
    /**
     * ログが作成された日付（YYYY-MM-DD HH:mm:ss）
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries
     */
    createdAt: string;
    /**
     * 企業ユーザID
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries
     */
    companyUserId: number;
    /**
     * 企業ユーザ名
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries
     */
    companyUserName: string;
    /**
     * 企業ユーザが削除されているか
     * @type {boolean}
     * @memberof PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries
     */
    isDeletedUser: boolean;
}

export function PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries {
    return PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logId': json['log_id'],
        'createdAt': json['created_at'],
        'companyUserId': json['company_user_id'],
        'companyUserName': json['company_user_name'],
        'isDeletedUser': json['is_deleted_user'],
    };
}

export function PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummariesToJSON(value?: PrtimesMediaListsSelectedMediaListsLogSummariesGetResponseAllOfSummaries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'log_id': value.logId,
        'created_at': value.createdAt,
        'company_user_id': value.companyUserId,
        'company_user_name': value.companyUserName,
        'is_deleted_user': value.isDeletedUser,
    };
}

